import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useLoader } from './LoaderContext';

function collectBackgroundImageUrls() {
  const urls = new Set();
  document.querySelectorAll('[style*="background-image"]').forEach((el) => {
    const match = el.style.backgroundImage.match(/url\(["']?(.*?)["']?\)/);
    if (match && match[1]) urls.add(match[1]);
  });
  return urls;
}

function waitForImages(timeoutMs = 8000) {
  return new Promise((resolve) => {
    const imgs = Array.from(document.images);
    const bgUrls = Array.from(collectBackgroundImageUrls());
    let pending = imgs.filter((img) => !img.complete).length + bgUrls.length;

    if (pending === 0) {
      resolve();
      return;
    }

    const done = () => {
      pending -= 1;
      if (pending <= 0) resolve();
    };

    imgs.forEach((img) => {
      if (!img.complete) {
        img.addEventListener('load', done, { once: true });
        img.addEventListener('error', done, { once: true });
      }
    });

    bgUrls.forEach((url) => {
      const preload = new Image();
      preload.onload = done;
      preload.onerror = done;
      preload.src = url;
    });

    setTimeout(resolve, timeoutMs);
  });
}

function NavigationLoader() {
  const { pathname } = useLocation();
  const { hideLoader } = useLoader();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    let cancelled = false;
    requestAnimationFrame(() => {
      waitForImages().then(() => {
        if (!cancelled) hideLoader();
      });
    });
    return () => {
      cancelled = true;
    };
  }, [pathname, hideLoader]);

  return null;
}

export default NavigationLoader;
